import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ListParams } from "../../../admin-api/games";
import { adminApi } from "../../../api-client";
import type { BroadcastNotification } from "../../../types";
import { queryKeys } from "../../query-keys";

export function useNotifications(params: ListParams = {}) {
	return useQuery({
		queryKey: queryKeys.notifications.list(params),
		queryFn: () => adminApi.notifications.list(params),
		placeholderData: keepPreviousData,
	});
}

export function useBroadcastNotification() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: BroadcastNotification) => adminApi.notifications.broadcast(data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.notifications.all,
			}),
	});
}
